function Checkbox({ children, disabled, checked, onChange }) {
  return (
      <input style={{zoom: '1.6', marginTop: '5px'}}
        type="checkbox"
        disabled={disabled}
        checked={checked}
        onChange={({ target: { checked } }) => onChange(checked)}
      />
  );
}

export default Checkbox;